import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { Settings, Home, Calendar, Image, Users, LogOut } from 'lucide-react';
import { getCurrentUser, logout } from '../../lib/auth';
import toast from 'react-hot-toast';

export default function AdminLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const user = await getCurrentUser();
      if (!user) {
        navigate('/admin/login');
      }
    };
    
    checkAuth();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin/login');
      toast.success('Logged out successfully');
    } catch (error) {
      toast.error('Error during logout');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex">
        {/* Enhanced Sidebar */}
        <div className="fixed top-0 left-0 h-full w-64 bg-white/95 backdrop-blur-xl shadow-lg z-layer-sidebar transition-all duration-300 overflow-y-auto admin-sidebar border-r border-pink-100/50">
          <div className="p-4">
            <div className="flex items-center space-x-2 mb-8 group">
              <div className="relative">
                <Settings className="h-6 w-6 text-pink-600 transform group-hover:rotate-90 transition-all duration-500" />
                <div className="absolute inset-0 bg-pink-400/20 blur-lg rounded-full opacity-0 group-hover:opacity-100 animate-pulse"></div>
              </div>
              <span className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Admin Panel</span>
            </div>
            <nav className="space-y-2">
              <Link
                to="/admin"
                className="group relative flex items-center space-x-2 p-3 rounded-lg hover:bg-gradient-to-r hover:from-pink-50 hover:to-purple-50 text-gray-700 hover:text-pink-600 transition-all duration-300 hover:shadow-md"
              >
                <Home className="h-5 w-5 transform group-hover:scale-110 transition-transform duration-300" />
                <span>Dashboard</span>
                <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-pink-600 to-purple-600 rounded-r opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </Link>
              <Link
                to="/admin/events"
                className="group flex items-center space-x-2 p-3 rounded-lg hover:bg-gradient-to-r hover:from-pink-50 hover:to-purple-50 text-gray-700 hover:text-pink-600 transition-all duration-300"
              >
                <Calendar className="h-5 w-5 transform group-hover:scale-110 transition-transform duration-300" />
                <span>Events</span>
                <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-pink-600 to-purple-600 rounded-r opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </Link>
              <Link
                to="/admin/gallery"
                className="group flex items-center space-x-2 p-3 rounded-lg hover:bg-gradient-to-r hover:from-pink-50 hover:to-purple-50 text-gray-700 hover:text-pink-600 transition-all duration-300"
              >
                <Image className="h-5 w-5 transform group-hover:scale-110 transition-transform duration-300" />
                <span>Gallery</span>
                <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-pink-600 to-purple-600 rounded-r opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </Link>
              <Link
                to="/admin/services"
                className="group flex items-center space-x-2 p-3 rounded-lg hover:bg-gradient-to-r hover:from-pink-50 hover:to-purple-50 text-gray-700 hover:text-pink-600 transition-all duration-300"
              >
                <Users className="h-5 w-5 transform group-hover:scale-110 transition-transform duration-300" />
                <span>Services</span>
                <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-pink-600 to-purple-600 rounded-r opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </Link>
              <button
                onClick={handleLogout}
                className="w-full group flex items-center space-x-2 p-3 rounded-lg hover:bg-gradient-to-r hover:from-pink-50 hover:to-purple-50 text-gray-700 hover:text-pink-600 transition-all duration-300"
              >
                <LogOut className="h-5 w-5 transform group-hover:scale-110 transition-transform duration-300" />
                <span>Logout</span>
                <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-pink-600 to-purple-600 rounded-r opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </nav>
          </div>
        </div>

        {/* Main content */}
        <div className="flex-1 ml-64 relative z-layer-content transition-all duration-300 bg-gradient-to-br from-gray-50 to-white">
          <header className="bg-white/95 backdrop-blur-xl shadow-sm sticky top-0 z-[80] border-b border-pink-100/50">
            <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
              <h1 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">
                Admin Panel
              </h1>
            </div>
          </header>
          <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 min-h-[calc(100vh-4rem)] transition-all duration-300">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}